<template>
    <div class="d-flex">
        <transition name="fade" mode="out-in">
            <VideoFrame v-if="videoFrameShow" :currentV="currentV" @back="videoFrameShow = false"/>
            
            <div v-else class="video-gallery-container">
                <div class="mb-5">
                    <VideoList @swVideo="swVideo" :videos="videos" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import VideoFrame from './VideoFrame'
import VideoList from './VideoList'

export default {
    components: {
        VideoList,
        VideoFrame,
    },
    props: ['videos'],
    data() {
        return {
            videoFrameShow: false,
            currentV: '',
        }
    },
    methods: {
        swVideo(currentV) {
            this.videoFrameShow = true
            this.currentV = currentV
            location.href = '#video';
        }
    }
}
</script>

<style lang="scss">
    
</style>